module.exports = __webpack_public_path__ + "static/media/caret-up.20ed70b3.svg";